<template>
  <Benefit
    :show-less-label="i18n(translations.showLessLabel)"
    :show-more-label="i18n(translations.showMoreLabel)"
  >
    <slot />
    <template #appendix>
      <slot name="appendix" />
    </template>
  </Benefit>
</template>

<script lang="ts" setup>
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import Benefit from '../Benefit/Benefit.vue'

import translations from './RegionalBenefit.translations'

const i18n = useI18n()
</script>
